import { Badge } from '@chakra-ui/react';

interface SentenceCountBadgeProps {
  count: number | undefined;
}

/**
 * Badge showing the number of sentences available for a word
 */
const SentenceCountBadge = ({ count }: SentenceCountBadgeProps) => {
  const displayCount = count ?? 0;
  const label = displayCount === 1 ? "sentence" : "sentences";
  const color = displayCount > 0 ? "green" : "red";

  return (
    <Badge colorScheme={color} borderRadius="full" px={2} py={1}>
      {displayCount} {label}
    </Badge>
  );
};

export default SentenceCountBadge;